import React from 'react';
import CoursesDataProvider from '../../../Utils/Courses/CoursesDataProvider';
import PropTypes from 'prop-types';
import { RecommendedCoursesContainer } from './RecommendedCourse.styles';
import EachRecommended from './EachRecommendedCourse.component';

const RecommendedCourses = ({ course }) => {
  return (
    <RecommendedCoursesContainer>
      <CoursesDataProvider>
        {(courses) => {
          return <EachRecommended courses={courses} course={course} />;
        }}
      </CoursesDataProvider>
    </RecommendedCoursesContainer>
  );
};
RecommendedCourses.propTypes = {
  course: PropTypes.shape({
    _id: PropTypes.string,
    courseName: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    price: PropTypes.number,
  }),
};
export default RecommendedCourses;
